/**
 * Created by henian.xu on 2021/10/26.
 *
 */
import Vue from 'vue';

export const state = Vue.observable({
    needRefresh: false,
});
